import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a98f3476"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "site-footer" }
const _hoisted_2 = { class: "site-margin-auto" }
const _hoisted_3 = { class: "footer-top" }
const _hoisted_4 = { class: "f-4" }
const _hoisted_5 = { style: {"font-size":"16px","color":"rgba(255, 255, 255, 0.7)","margin-bottom":"30px","text-align":"center"} }
const _hoisted_6 = { style: {"font-size":"16px","text-align":"center"} }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "f-2" }, " 版权所有：安徽省招标集团股份有限公司 ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "f-2" }, " 24小时服务热线：0551-62220000 ", -1))
const _hoisted_9 = { class: "footer-bottom" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "CopyRight© 2024", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "版权所有：安徽省招标集团股份有限公司", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://beian.miit.gov.cn",
    target: "_blank",
    class: "f-3"
  }, " 皖ICP备05004986号-3 ")
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "运营支持：安徽智云上数字科技有限公司 ", -1))

import { LinkNode } from "./link-node";
import { useUserStore } from "@/store/modules/user/index";


export default /*#__PURE__*/_defineComponent({
  __name: 'app-footer',
  setup(__props) {

const userStore = useUserStore();

const changeTab = (activeKey: string) => {
  userStore.setMenuKey(activeKey);
};

return (_ctx: any,_cache: any) => {
  const _component_a_space = _resolveComponent("a-space")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_a_space, { size: 26 }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: "f-1",
                  onClick: _cache[0] || (_cache[0] = () => changeTab('/'))
                }, [
                  _createTextVNode(" 网站首页 "),
                  _createVNode(_unref(LinkNode), { path: "/" })
                ]),
                _createTextVNode(" | "),
                _createElementVNode("div", {
                  class: "f-1",
                  onClick: _cache[1] || (_cache[1] = () => changeTab('/site-search?pType=1'))
                }, [
                  _createTextVNode(" 招标采购 "),
                  _createVNode(_unref(LinkNode), { path: "/site-search?pType=1" })
                ]),
                _createTextVNode(" | "),
                _createElementVNode("div", {
                  class: "f-1",
                  onClick: _cache[2] || (_cache[2] = () => changeTab('/site-search?pType=2'))
                }, [
                  _createTextVNode(" 政府采购 "),
                  _createVNode(_unref(LinkNode), { path: "/site-search?pType=2" })
                ]),
                _createTextVNode(" | "),
                _createElementVNode("div", {
                  class: "f-1",
                  onClick: _cache[3] || (_cache[3] = () => changeTab('/site-search?pType=3'))
                }, [
                  _createTextVNode(" 寻源快采 "),
                  _createVNode(_unref(LinkNode), { path: "/site-search?pType=3" })
                ]),
                _createTextVNode(" | "),
                _createElementVNode("div", {
                  class: "f-1",
                  onClick: _cache[4] || (_cache[4] = () => changeTab('/site-statute'))
                }, [
                  _createTextVNode(" 政策法规 "),
                  _createVNode(_unref(LinkNode), { path: "/site-statute" })
                ]),
                _createTextVNode(" | "),
                _createElementVNode("div", {
                  class: "f-1",
                  onClick: _cache[5] || (_cache[5] = () => changeTab('/site-info'))
                }, [
                  _createTextVNode(" 行业资讯 "),
                  _createVNode(_unref(LinkNode), { path: "/site-info" })
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_a_space, { size: 26 }, {
              default: _withCtx(() => [
                _hoisted_7,
                _hoisted_8
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_a_space, { size: 15 }, {
          default: _withCtx(() => [
            _hoisted_10,
            _hoisted_11,
            _hoisted_12,
            _hoisted_13
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})